var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIconExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 15,
    viewBox: "0 0 4 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.369191 9.57755L0.19934 0H2.87222L2.69265 9.57755H0.369191ZM1.54032 14.2068C1.33734 14.2138 1.13503 14.1801 0.945261 14.1079C0.755496 14.0357 0.582116 13.9263 0.435316 13.7862C0.292746 13.6495 0.18044 13.4844 0.105631 13.3018C0.0308222 13.1191 -0.0048318 12.9228 0.000965209 12.7255C-0.00640224 12.5259 0.0284734 12.3271 0.103316 12.1418C0.178159 11.9566 0.291287 11.7893 0.435316 11.6506C0.582924 11.5121 0.756574 11.4041 0.946236 11.3329C1.1359 11.2617 1.33781 11.2287 1.54032 11.2358C1.74282 11.2287 1.94474 11.2617 2.1344 11.3329C2.32406 11.4041 2.49771 11.5121 2.64532 11.6506C2.78935 11.7893 2.90248 11.9566 2.97732 12.1418C3.05216 12.3271 3.08704 12.5259 3.07967 12.7255C3.08547 12.9228 3.04981 13.1191 2.97501 13.3018C2.9002 13.4844 2.78789 13.6495 2.64532 13.7862C2.49849 13.9262 2.3251 14.0355 2.13534 14.1077C1.94558 14.1799 1.74327 14.2138 1.54032 14.2068Z",
    fill: "var(--Shades-00, #FFF)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconExclamation);
export default __webpack_public_path__ + "static/media/error-icon-exclamation.581d2a78e3a2775c5921474cdbbf67bf.svg";
export { ForwardRef as ReactComponent };